export const ROUTES = {
  SUPERVISORS: "supervisors",
  SUPERVISOR_ROUTES: "supervisor-routes",
};
